import BaseService from '@/scripts/services/base/base.service'

export default class AuthService extends BaseService {
    constructor() {
        super('Auth')
    }

    //User Region
    login(username, password) {
        return this.postRequest('Login', { username, password }, false)
    }

    countUsers(filters) {
        return this.postRequest('CountUsers', filters)
    }

    listUsers(filters) {
        return this.postRequest('ListAllUsers', filters)
    }

    updateUserStatus(userEntityId) {
        return this.getRequest('UpdateUserStatus', { userEntityId })
    }

    getUserById(id) {
        return this.getRequest('FindUserById', { id })
    }

    createUser(user) {
        return this.postRequest('CreateUser', user)
    }

    editUser(user) {
        return this.postRequest('EditUser', user)
    }

    listAllUserEntities(userId, loggedEntityId) {
        return this.getRequest('GetUserEntitiesToFillDetails', { userId, loggedEntityId })
    }

    deleteUserEntity(userEntityId) {
        return this.getRequest('DeleteUserEntity', { userEntityId })
    }

    updateUserEntityStatus(userEntityId) {
        return this.getRequest('UpdateUserEntity', { userEntityId })
    }

    getLoggedUser(){
        return this.getRequest('GetLoggedUser')
    }
    //End of User Region

    //Agent Region
    loginAgent(username, password) {
        return this.postRequest('LoginAgent', { username, password }, false)
    }

    getLoggedAgent() {
        return this.getRequest('GetLoggedAgent')
    }

    createAgent(agent) {
        return this.postRequest('CreateAgent', agent)
    }

    editAgent(agent) {
        return this.postRequest('EditAgent', agent)
    }

    loadAgentNameAndEmail() {
        return this.getRequest('GetLoggedAgentNameAndEmail')
    }

    loadUserNameAndEmail() {
        return this.getRequest('GetLoggedUserNameAndEmail')
    }
    //Enf of Agent Region

    //Person Region
    createPerson(person) {
        return this.postRequest('CreatePerson', person)
    }

    updatePerson(person) {
        return this.postRequest('UpdatePerson', person)
    }

    //End of Person Region

    getUserEntities(){
        return this.getRequest('GetUserEntities')
    }

    changePassword(passwordModel) {
        return this.postRequest('ChangePassword', passwordModel)
    }

    changeRecoveredPassword(hash, newPassword) {
        return this.postRequest('ChangeRecoveredPassword', {
            hash,
            newPassword,
        })
    }

    logOut() {
        return this.getRequest('LogOut')
    }

    recoverPassword(information) {
        return this.getRequest('RecoverPassword', { information: information })
    }

    resendRecoverPasswordEmail(hash) {
        return this.getRequest('ResendRecoverPasswordEmail', {
            hash: hash,
        })
    }
}
